import flow from 'lodash/fp/flow';

import type { RootState } from '../../../configuration/setup/store';

const baseSelector = (state: RootState) => state.widget;

export const getWidgetVisibility = flow(baseSelector, subState => subState.visible);
